// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.close-button {
  position: fixed;
  top: 8px;
  right: 6px;
  color: rgb(252, 252, 252);
  font-size: 10pt;
  z-index: 500;
}

/**************************** DESKTOP *******************************************************************************/
.panel {
  margin: 8px 8px 8px 8px;
}

.tarjeta-contenedor {
  background-color: white;
  width: 100%;
  height: 100%;
}
.tarjeta-contenedor .img-cvv {
  height: 37px;
  max-height: 37px;
}
.tarjeta-contenedor .tarjeta-cabecera {
  text-align: center;
  align-content: center;
  vertical-align: middle;
  padding: 8px;
  background-color: #52d05b;
  width: 100%;
  height: 70px;
  overflow: hidden;
  box-shadow: 0px 1px 3px 2px rgba(0, 0, 0, 0.6);
  z-index: 100;
}
.tarjeta-contenedor .tarjeta-cabecera .cabecera-texto {
  position: relative;
  color: #ffffff;
  font-weight: bold;
  top: 8px;
}
.tarjeta-contenedor .tarjeta-cuerpo {
  height: calc(100% - 70px);
}
.tarjeta-contenedor .tarjeta-cuerpo .tarjeta-formulario {
  padding: 8px;
}
.tarjeta-contenedor .tarjeta-cuerpo .tarjeta-formulario .logo-cc {
  position: relative;
  top: -4px;
  color: #5f5f5f;
}
.tarjeta-contenedor .tarjeta-cuerpo .contenedor-conceptos {
  padding: 8px;
}
.tarjeta-contenedor .tarjeta-cuerpo .contenedor-conceptos-desktop {
  background-color: #efefef;
  padding: 8px;
  min-height: 100%;
  height: 100%;
  box-shadow: -1px 4px 3px 1px rgba(0, 0, 0, 0.6);
  z-index: 50;
}
.tarjeta-contenedor .tarjeta-cuerpo .contenedor-conceptos-desktop .btn-volver {
  align-self: center;
  padding-top: 10px;
}
.tarjeta-contenedor .cvv-hint {
  position: relative;
  top: -22px;
}
.tarjeta-contenedor .imagen-stripe {
  width: 320px;
  margin-top: 50px;
  align-self: center;
}
.tarjeta-contenedor mat-form-field {
  margin-left: 15px;
  margin-right: 15px;
  margin-top: 12px;
}
.tarjeta-contenedor mat-form-field .mat-form-field-outline-start {
  border: solid 2px #ccc;
}

/**************************** MOBILE *******************************************************************************/
.tarjeta-contenedor-mobile {
  background-color: white;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
}
.tarjeta-contenedor-mobile .img-cvv {
  height: 37px;
  max-height: 37px;
}
.tarjeta-contenedor-mobile .tarjeta-cabecera-mobile {
  position: fixed;
  text-align: center;
  align-content: center;
  vertical-align: middle;
  padding: 8px;
  background-color: #52d05b;
  width: 100%;
  height: 70px;
  overflow: hidden;
  box-shadow: 0px 1px 3px 2px rgba(0, 0, 0, 0.6);
  z-index: 100;
}
.tarjeta-contenedor-mobile .tarjeta-cabecera-mobile .cabecera-texto {
  position: relative;
  color: #ffffff;
  font-weight: bold;
  top: 8px;
}
.tarjeta-contenedor-mobile .tarjeta-cuerpo {
  padding-top: 80px;
  height: 100vh;
}
.tarjeta-contenedor-mobile .tarjeta-cuerpo .tarjeta-formulario {
  padding: 8px;
}
.tarjeta-contenedor-mobile .tarjeta-cuerpo .tarjeta-formulario .logo-cc {
  position: relative;
  top: -4px;
  color: #ffffff;
}
.tarjeta-contenedor-mobile .tarjeta-cuerpo .contenedor-conceptos {
  padding: 8px;
}
.tarjeta-contenedor-mobile .tarjeta-cuerpo .contenedor-conceptos-desktop {
  background-color: #f3f3f3;
  padding: 8px;
  min-height: 100%;
  height: 100%;
  box-shadow: -1px 4px 3px 1px rgba(0, 0, 0, 0.6);
  z-index: 50;
}
.tarjeta-contenedor-mobile .tarjeta-cuerpo .contenedor-conceptos-desktop .btn-volver {
  align-self: center;
  padding-top: 10px;
}
.tarjeta-contenedor-mobile .cvv-hint {
  position: relative;
  top: -22px;
}
.tarjeta-contenedor-mobile .imagen-stripe.movil {
  width: 320px;
  margin-top: 20px;
  align-self: center;
}
.tarjeta-contenedor-mobile mat-form-field {
  margin-left: 0;
  margin-right: 0;
  margin-top: 12px;
}
.tarjeta-contenedor-mobile mat-form-field .mat-form-field-outline-start {
  border: solid 2px #ccc;
}

/**************************** EXTRA *******************************************************************************/
mat-hint {
  font-style: italic;
  font-weight: bold;
  font-size: 0.75rem;
}

.alto30 {
  height: 30px !important;
  min-height: 30px !important;
}

.alto60 {
  height: 60px !important;
  min-height: 60px !important;
}

.alto100 {
  height: 100vh !important;
  min-height: 100vh !important;
}

.pagar {
  align-self: center !important;
  width: 90% !important;
}`, "",{"version":3,"sources":["webpack://./src/app/componentes/pasarela-stripe/pasarela-stripe.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,QAAA;EACA,UAAA;EACA,yBAAA;EACA,eAAA;EACA,YAAA;AACF;;AAEA,qHAAA;AACA;EAGC,uBAAA;AADD;;AAGA;EACE,uBAAA;EACA,WAAA;EACA,YAAA;AAAF;AAEE;EACE,YAAA;EACA,gBAAA;AAAJ;AAGE;EACE,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,YAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EAGA,8CAAA;EACA,YAAA;AADJ;AAGI;EACE,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,QAAA;AADN;AAIE;EACE,yBAAA;AAFJ;AAGI;EACE,YAAA;AADN;AAEM;EACE,kBAAA;EACA,SAAA;EACA,cAAA;AAAR;AAII;EACE,YAAA;AAFN;AAII;EACE,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EAGA,+CAAA;EACA,WAAA;AAFN;AAGM;EACE,kBAAA;EACA,iBAAA;AADR;AAKE;EACE,kBAAA;EACA,UAAA;AAHJ;AAME;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;AAJJ;AAME;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;AAJJ;AAMI;EACE,sBAAA;AAJN;;AAQA,oHAAA;AAEA;EACE,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AANF;AAQE;EACE,YAAA;EACA,gBAAA;AANJ;AAaE;EACE,eAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,YAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EAGA,8CAAA;EACA,YAAA;AAXJ;AAaI;EACE,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,QAAA;AAXN;AAcE;EACE,iBAAA;EAEA,aAAA;AAbJ;AAcI;EACE,YAAA;AAZN;AAaM;EACE,kBAAA;EACA,SAAA;EACA,cAAA;AAXR;AAeI;EACE,YAAA;AAbN;AAeI;EACE,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EAGA,+CAAA;EACA,WAAA;AAbN;AAcM;EACE,kBAAA;EACA,iBAAA;AAZR;AAgBE;EACE,kBAAA;EACA,UAAA;AAdJ;AAiBE;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;AAfJ;AAiBE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAfJ;AAiBI;EACE,sBAAA;AAfN;;AAoBA,mHAAA;AACA;EACE,kBAAA;EACA,iBAAA;EACA,kBAAA;AAjBF;;AAoBA;EACE,uBAAA;EACA,2BAAA;AAjBF;;AAmBA;EACE,uBAAA;EACA,2BAAA;AAhBF;;AAmBA;EACE,wBAAA;EACA,4BAAA;AAhBF;;AAkBA;EACE,6BAAA;EACA,qBAAA;AAfF","sourcesContent":[".close-button {\r\n  position: fixed;\r\n  top: 8px;\r\n  right: 6px;\r\n  color: rgb(252, 252, 252);\r\n  font-size: 10pt;\r\n  z-index: 500;\r\n}\r\n\r\n/**************************** DESKTOP *******************************************************************************/\r\n.panel{\r\n\t// box-shadow: none;\r\n\t// border-bottom: 1px solid rgb(114, 114, 114);\r\n\tmargin: 8px 8px 8px 8px;\r\n}\r\n.tarjeta-contenedor {\r\n  background-color: white;\r\n  width: 100%;\r\n  height: 100%;\r\n\r\n  .img-cvv {\r\n    height: 37px;\r\n    max-height: 37px;\r\n  }\r\n\r\n  .tarjeta-cabecera {\r\n    text-align: center;\r\n    align-content: center;\r\n    vertical-align: middle;\r\n    padding: 8px;\r\n    background-color: #52d05b;\r\n    width: 100%;\r\n    height: 70px;\r\n    overflow: hidden;\r\n    -webkit-box-shadow: 0px 1px 3px 2px rgba(0, 0, 0, 0.6);\r\n    -moz-box-shadow: 0px 1px 3px 2px rgba(0, 0, 0, 0.6);\r\n    box-shadow: 0px 1px 3px 2px rgba(0, 0, 0, 0.6);\r\n    z-index: 100;\r\n\r\n    .cabecera-texto {\r\n      position: relative;\r\n      color: #ffffff;\r\n      font-weight: bold;\r\n      top: 8px;\r\n    }\r\n  }\r\n  .tarjeta-cuerpo {\r\n    height: calc(100% - 70px);\r\n    .tarjeta-formulario {\r\n      padding: 8px;\r\n      .logo-cc {\r\n        position: relative;\r\n        top: -4px;\r\n        color: #5f5f5f;\r\n      }\r\n    }\r\n\r\n    .contenedor-conceptos {\r\n      padding: 8px;\r\n    }\r\n    .contenedor-conceptos-desktop {\r\n      background-color: #efefef;\r\n      padding: 8px;\r\n      min-height: 100%;\r\n      height: 100%;\r\n      -webkit-box-shadow: -1px 4px 3px 1px rgba(0, 0, 0, 0.6);\r\n      -moz-box-shadow: -1px 4px 3px 1px rgba(0, 0, 0, 0.6);\r\n      box-shadow: -1px 4px 3px 1px rgba(0, 0, 0, 0.6);\r\n      z-index: 50;\r\n      .btn-volver {\r\n        align-self: center;\r\n        padding-top: 10px;\r\n      }\r\n    }\r\n  }\r\n  .cvv-hint {\r\n    position: relative;\r\n    top: -22px;\r\n  }\r\n\r\n  .imagen-stripe {\r\n    width: 320px;\r\n    margin-top: 50px;\r\n    align-self: center;\r\n  }\r\n  mat-form-field {\r\n    margin-left: 15px;\r\n    margin-right: 15px;\r\n    margin-top: 12px;\r\n\r\n    .mat-form-field-outline-start {\r\n      border: solid 2px #ccc;\r\n    }\r\n  }\r\n}\r\n/**************************** MOBILE *******************************************************************************/\r\n\r\n.tarjeta-contenedor-mobile {\r\n  background-color: white;\r\n  width: 100%;\r\n  height: 100%;\r\n  overflow-x: hidden;\r\n\r\n  .img-cvv {\r\n    height: 37px;\r\n    max-height: 37px;\r\n  }\r\n  // .nombre{\r\n  //   padding-left: 10px !important;\r\n  //   padding-right: 10px !important;\r\n  // }\r\n\r\n  .tarjeta-cabecera-mobile {\r\n    position: fixed;\r\n    text-align: center;\r\n    align-content: center;\r\n    vertical-align: middle;\r\n    padding: 8px;\r\n    background-color: #52d05b;\r\n    width: 100%;\r\n    height: 70px;\r\n    overflow: hidden;\r\n    -webkit-box-shadow: 0px 1px 3px 2px rgba(0, 0, 0, 0.6);\r\n    -moz-box-shadow: 0px 1px 3px 2px rgba(0, 0, 0, 0.6);\r\n    box-shadow: 0px 1px 3px 2px rgba(0, 0, 0, 0.6);\r\n    z-index: 100;\r\n\r\n    .cabecera-texto {\r\n      position: relative;\r\n      color: #ffffff;\r\n      font-weight: bold;\r\n      top: 8px;\r\n    }\r\n  }\r\n  .tarjeta-cuerpo {\r\n    padding-top: 80px;\r\n    // height: calc(100% - 70px);\r\n    height: 100vh;\r\n    .tarjeta-formulario {\r\n      padding: 8px;\r\n      .logo-cc {\r\n        position: relative;\r\n        top: -4px;\r\n        color: #ffffff;\r\n      }\r\n    }\r\n\r\n    .contenedor-conceptos {\r\n      padding: 8px;\r\n    }\r\n    .contenedor-conceptos-desktop {\r\n      background-color: #f3f3f3;\r\n      padding: 8px;\r\n      min-height: 100%;\r\n      height: 100%;\r\n      -webkit-box-shadow: -1px 4px 3px 1px rgba(0, 0, 0, 0.6);\r\n      -moz-box-shadow: -1px 4px 3px 1px rgba(0, 0, 0, 0.6);\r\n      box-shadow: -1px 4px 3px 1px rgba(0, 0, 0, 0.6);\r\n      z-index: 50;\r\n      .btn-volver {\r\n        align-self: center;\r\n        padding-top: 10px;\r\n      }\r\n    }\r\n  }\r\n  .cvv-hint {\r\n    position: relative;\r\n    top: -22px;\r\n  }\r\n\r\n  .imagen-stripe.movil {\r\n    width: 320px;\r\n    margin-top: 20px;\r\n    align-self: center;\r\n  }\r\n  mat-form-field {\r\n    margin-left: 0;\r\n    margin-right: 0;\r\n    margin-top: 12px;\r\n\r\n    .mat-form-field-outline-start {\r\n      border: solid 2px #ccc;\r\n    }\r\n  }\r\n}\r\n\r\n/**************************** EXTRA *******************************************************************************/\r\nmat-hint {\r\n  font-style: italic;\r\n  font-weight: bold;\r\n  font-size: 0.75rem;\r\n}\r\n\r\n.alto30 {\r\n  height: 30px !important;\r\n  min-height: 30px !important;\r\n}\r\n.alto60 {\r\n  height: 60px !important;\r\n  min-height: 60px !important;\r\n}\r\n\r\n.alto100 {\r\n  height: 100vh !important;\r\n  min-height: 100vh !important;\r\n}\r\n.pagar {\r\n  align-self: center !important;\r\n  width: 90% !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
